<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card class="elevation-0">
      <v-toolbar :color="this.getAppBarColor" dark>Nova Campanha</v-toolbar>

      <v-card-text>
        <v-form ref="form">
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="form.nome"
                label="Noma da Campanha"
                type="text"
                prepend-inner-icon="mdi-card-text"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12">
              <DateMenu label="Data de Expiração" @onChanged="form.dataExpiracao = $event" />
            </v-col>
            <v-col cols="12">
              <SelectEmpresa :multiple="true" @onChanged="form.empresas = $event" prepend-icon="mdi-domain" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-row dense>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-3 pl-5 pr-5"
            outlined
            color="blue darken-1"
            small
            dark
            rounded
            depressed
            @click="save()"
          >
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>

          <v-btn
            class="ma-3 pl-5 pr-5"
            outlined
            color="red darken-2"
            small
            dark
            rounded
            depressed
            @click="hide()"
          >
            <v-icon left>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from "@/utils/rules";
import { Campanhas } from "@/services/materiais";

export default {
  name: "DialogCreateCampanha",

  components: {
    DateMenu: () => import("@/components/datepicker/DateMenu"),
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },

  data() {
    return {
      dialog: false,

      form: {
        nome: "",
        dataExpiracao: "",
        empresas: []
      },

      rules: rules
    };
  },

  methods: {
    show() {
      this.form.nome = "";
      this.dialog = true;
    },

    hide() {
      this.dialog = false;
    },

    async save() {
      if (!this.$refs.form.validate() || this.form.empresas.length <= 0 || !this.form.dataExpiracao) {
        this.$toast.warning("Por favor, preencha todos os campos corretamente");
        return;
      }

      try {
        const response = await new Campanhas().create(this.form);
        this.$toast.success(response);
        this.form.nome = "";
        this.$refs.form.resetValidation();
        this.$emit("created");
      } catch (error) {
        this.$toast.error(error);
      }
    }
  }
};
</script>
